import type { ToolResult } from "@/types/tools";

export type UrlEncodingMode = "component" | "full-url";

export type ParsedUrl = {
  href: string;
  origin: string;
  protocol: string;
  username: string;
  password: string;
  hostname: string;
  port: string;
  pathname: string;
  search: string;
  hash: string;
  queryParams: Array<{
    key: string;
    value: string;
  }>;
};

export function parseUrl(input: string): ToolResult<ParsedUrl> {
  try {
    const url = new URL(input.trim());
    const queryParams: ParsedUrl["queryParams"] = [];

    url.searchParams.forEach((value, key) => {
      queryParams.push({ key, value });
    });

    return {
      ok: true,
      value: {
        href: url.href,
        origin: url.origin,
        protocol: url.protocol,
        username: url.username,
        password: url.password,
        hostname: url.hostname,
        port: url.port,
        pathname: url.pathname,
        search: url.search,
        hash: url.hash,
        queryParams,
      },
    };
  } catch {
    return {
      ok: false,
      error: "Enter a complete URL, including a valid protocol such as https://.",
    };
  }
}

export function encodeUrlText(input: string, mode: UrlEncodingMode): string {
  return mode === "full-url" ? encodeURI(input) : encodeURIComponent(input);
}

export function decodeUrlText(input: string, mode: UrlEncodingMode): ToolResult<string> {
  try {
    return {
      ok: true,
      value: mode === "full-url" ? decodeURI(input) : decodeURIComponent(input),
    };
  } catch {
    return {
      ok: false,
      error: "Enter valid percent-encoded text. Percent escapes must use two hex characters.",
    };
  }
}
